import destinationList from '~/js/views/weddings/includes/destinations-list.js';
const thumbs = Array.from(document.querySelectorAll('#hm-destWrapper .hm-dest-thumb'));
const slideWrap = document.getElementById('hmSlideWrap');
const destDetails = document.getElementById('hm-destDetails');

const showNextImage = () => {
    const $actEl = document.querySelector('li.active');
    const $nextEl = $actEl.nextElementSibling;

    if ($nextEl.tagName === 'LI') {
        $actEl.classList.remove('active');
        $nextEl.classList.add('active');
    } else {
        $actEl.classList.remove('active');
        document.querySelector('.destSlideshow li:first-of-type').classList.add('active');
    }
};
const showPreviousImage = () => {
    const $actEl = document.querySelector('li.active');
    let $prevEl;

    if ($actEl.previousElementSibling === null) {
        $prevEl = document.querySelector('.destSlideshow li:last-of-type');
    } else {
        $prevEl = $actEl.previousElementSibling;
    }
    if ($prevEl.tagName === 'LI') {
        $actEl.classList.remove('active');
        $prevEl.classList.add('active');
    } else {
        $actEl.classList.remove('active');
        document.querySelector('.destSlideshow li:last-of-type').classList.add('active');
    }
};

const showDestination = (target) => {
    thumbs.forEach(thumb => {
        thumb.classList.add('hideThumb');
    });
    const contentID = target.getAttribute('data-dest');
    const targetDest = destinationList[contentID];
    const resorts = targetDest.resorts;
    const arrayOfResorts = [];

    resorts.forEach(resort => {
        arrayOfResorts.push(`
            <li>
                <div class='top-container col-xs-12'>
                    <div class='resort-name col-xs-10 col-sm-8 col-md-6'>
                        <div class='text-wrap'>
                            <h3><i class='ic ic-logo-sandals'></i> ${resort.resortName}</h3><h4>${resort.city}, ${targetDest.destination}</h4>
                        </div>
                    </div>
                    <img src='//cdn.sandals.com/sandals/v12/images/weddings/includes/destinations/dest-${resort.code}.jpg' />
                </div>
                <p class='col-xs-8 col-xs-offset-2'>${resort.description}</p>
                <a class='learnmore titleCopy col-xs-8 col-xs-offset-2' href='${resort.resortLink}'>View Resort<i class='ic ic-button-arrow-next'></i></a>
            </li>`);
    });
    const slideList = `
    <ul class='destSlideshow'>
        <li class='active'>
            <div class='top-container col-xs-12'>
                <div class='dest-title col-xs-12'>
                    <h4>${targetDest.destination}</h4><h6>${targetDest.subtitle}</h6>
                </div>
                <img src='//cdn.sandals.com/sandals/v12/images/weddings/includes/destinations/dest-${targetDest.img}.jpg'/>
            </div>
            <p class='col-xs-8 col-xs-offset-2'>${targetDest.description}</p>
        </li>
        ${arrayOfResorts.join('')}
        <div class='destNav'><a class='destPrev'><i class='ic ic-button-arrow-prev'></i></a><a class='destNext'><i class='ic ic-button-arrow-next'></i></a></div>
    </ul>`;

    slideWrap.innerHTML = '';
    destDetails.classList.add('showSlide');
    slideWrap.innerHTML = slideList;
};


document.onclick = (event) => {

    const ep = event.target;

    if (!Element.prototype.matches) {
        if (ep.webkitMatchesSelector) {
            ep.matches = ep.webkitMatchesSelector;
        }

        if (ep.msMatchesSelector) {
            ep.matches = ep.msMatchesSelector;
        }

        if (ep.mozMatchesSelector) {
            ep.matches = ep.mozMatchesSelector;
        }
    }

    if (ep.matches('.hm-dest-thumb, .hm-dest-thumb *')) {
        let target;

        if (!ep.matches('.hm-dest-thumb')) {
            target = event.target.parentElement;
        } else {
            target = event.target;
        }
        showDestination(target);
    }

    if (ep.matches('.destPrev, .destPrev *')) {
        showPreviousImage();
        return false;
    }

    if (ep.matches('.destNext, .destNext *')) {
        showNextImage();
        return false;
    }

    if (ep.matches('.close')) {
        thumbs.forEach(thumb => {
            thumb.classList.remove('hideThumb');
        });
        destDetails.classList.remove('showSlide');
    }
};
